import React from "react";
import Lottie from "react-lottie-player";
import StateAnimation from "./defaultStateAnimation.json";

export default function LoadingState() {
  return (
    <div className="d-flex flex-column w-100 h-100 align-items-center">
      <Lottie
        loop
        animationData={StateAnimation}
        play
        style={{ width: 300, height: 300 }}
      />
      <p className="m-0 fw-semiobold opacity-75">Processing... Please wait.</p>
    </div>
  );
}
